/* eslint-disable prefer-destructuring */
/* eslint-disable no-case-declarations */
import React from 'react'
import DialogFooter from '../DialogFooter'
import DialogHeader from '../DialogHeader'
import DialogMain from '../DialogMain'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useForm } from 'react-hook-form'
import ErrorText from '../../ui/ErrorText'
import { TextareaAutosize } from '@mui/base'
import { useSelector } from 'react-redux'
import { getNotif, notifsActions } from 'src/old-app/store/notifSlice'
import { useDeclineProjectMutation } from 'src/old-app/service/Projects'
import { notifTypes } from 'src/old-app/constants/notifications'
import { useDispatch } from 'react-redux'
import { dialogActions } from 'src/old-app/store/dialogSlice'
import { showMessage } from 'src/old-app/store/fuse/messageSlice'
import { useDeleteOneNotifMutation } from 'src/old-app/service/Notif'
import { interfaceActions } from 'src/old-app/store/interfaceSlice'
import {
	useCancelTaskDeadlineMutation,
	useCancelTaskMutation,
	useDeclineTaskDeadlineMutation,
	useDeclineTaskMutation,
	useUpdateTaskMutation,
} from 'src/old-app/service/Tasks'
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom'
import { getRequest, requestsActions } from 'src/old-app/store/requestSlice'
import { tasksActions } from 'src/old-app/store/tasksSlice'
import { scrumboardActions } from 'src/old-app/store/scrumboardSlice'
import { requestType } from 'src/entities/task'
import { useTranslation } from 'react-i18next'

const CancelRequest = () => {
	const { t } = useTranslation()
	const schema = yup.object().shape({
		comment: yup.string().required(t('comment_is_required')),
	})
	const { notifId } = useParams()
	const navigate = useNavigate()
	const { search, pathname } = useLocation()
	const dispatch = useDispatch()
	const [declineProject] = useDeclineProjectMutation()
	const [declineTaskDeadline] = useDeclineTaskDeadlineMutation()
	const [declineTask] = useDeclineTaskMutation()
	const request = useSelector(getRequest)
	const [updateTask] = useUpdateTaskMutation()
	const [cancelTask] = useCancelTaskMutation()
	const [cancelTaskDeadline] = useCancelTaskDeadlineMutation()
	const [deleteNotif, deleteResult] = useDeleteOneNotifMutation()

	const {
		setValue,
		handleSubmit,
		register,
		formState: { errors },
	} = useForm({
		defaultValues: {},
		resolver: yupResolver(schema),
	})

	const closeHandler = (message) => {
		dispatch(
			showMessage({
				message,
				autoHideDuratigon: 1000,
				anchorOrigin: {
					vertical: 'top',
					horizontal: 'top-right',
				},
				variant: 'success',
			})
		)
		dispatch(dialogActions.setDialog(false))
		dispatch(interfaceActions.setIsLoading(false))
		if (request?.backRoute) {
			return navigate(`${request?.backRoute}${search}`)
		}
		navigate(`${pathname}${search}`)
	}

	const cancelHandler = async (data) => {
		dispatch(interfaceActions.setIsLoading(true))

		switch (request.type) {
			case requestType.TASK_STATUS:
				await declineTask({
					...data,
					task_id: request.id,
				})

				closeHandler(t('rejected'))

				break

			case requestType.USER_CANCEL_TASK_STATUS:
				await cancelTask({
					...data,
					task_id: request.id,
				})

				closeHandler(t('canceled'))

				break

			case requestType.USER_CANCEL_TASKS_DEADLINE:
				await cancelTaskDeadline({ id: request.id, body: data })
				closeHandler(t('canceled'))

				break

			case requestType.TASKS_DEADLINE:
				await declineTaskDeadline({ id: request.id, body: data })
				closeHandler(t('rejected'))

				break

			default:
				break
		}
	}
	return (
		<form onSubmit={handleSubmit(cancelHandler)} className="tt-w-600">
			<DialogHeader title={t('cancel_with_comment')} />
			<DialogMain>
				<div className="tt-flex tt-flex-col tt-gap-16">
					<div className="tt-flex tt-flex-col tt-w-full">
						<span className="tt-text-14 tt-font-semibold tt-mb-4">{t('comment')}</span>
						<TextareaAutosize
							minRows={3}
							maxRows={10}
							{...register('comment')}
							error={!!errors.comment}
							placeholder={t('comment')}
							size="small"
							aria-label="minimum height"
							className="tt-border tt-border-gray-300 tt-p-12  tt-rounded-lg"
						/>
						<ErrorText errors={errors} field="comment" />
					</div>
				</div>
			</DialogMain>
			<DialogFooter rightLabel={t('send')} />
		</form>
	)
}

export default CancelRequest
